import { useTheme, Stack, Typography, Button, Divider, Paper, TextField, InputAdornment, IconButton, Toolbar } from "@mui/material";
import { Search } from "react-bootstrap-icons";
import { IGenericTable } from "src/types/organisms";
import DataTable from "@components/molecules/DataTable/DataTable";
const GenericTable = ({
  title,
  buttonLabel,
  onClick,
  isLoading = false,
  headers,
  rows,
  pages,
  currentPage,
  onChangePage,
  emptyMessage = "Sin elementos encontrados",
  searchLabel = "Buscar cliente",
  onSearch,
  onSearchClick,
  moreFilters
}: IGenericTable) => {
  const theme = useTheme();
  const classes = {
    root: {
      marginTop: 4,
      padding: "24px",
      paddingTop: 2
    },
    toolbar: {
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 2
    },
    search: {
      maxWidth: "240px",
      "&:placeholder": {
        fontSize: "10px"
      },
      "& input": {
        paddingY: "10px"
      }
    }
  };
  return <Paper elevation={12} sx={classes.root}>
      <Toolbar component={Stack} direction={"row"} sx={classes.toolbar}>
        <Typography variant="h6" fontWeight={700}>
          {title}
        </Typography>
        <Stack direction={"row"} alignItems={"center"} spacing={3}>
          {moreFilters}
          <TextField id="search" variant="outlined" placeholder={searchLabel} type="text" sx={classes.search} onChange={value => onSearch(value.target.value)} InputProps={{
          endAdornment: <InputAdornment position="end">
                  <IconButton edge="end" onClick={onSearchClick}>
                    <Search color={theme.palette.primary.main} fontWeight={700} strokeWidth={2} size={18} />
                  </IconButton>
                </InputAdornment>
        }} />
          <Button onClick={onClick} size="large">
            {buttonLabel}
          </Button>
        </Stack>
      </Toolbar>
      <Divider />
      <DataTable isLoading={isLoading} headers={headers} rows={rows} pages={pages} currentPage={currentPage} onChangePage={onChangePage} emptyMessage={emptyMessage} />
    </Paper>;
};
export default GenericTable;